import tw from 'tailwind-styled-components'
import {IconTabler} from '@components/common/icon-tabler/icon-tabler'

export const TwIconLeft = tw.div<{$paddingRight: '4' | '8' | '12'}>`
  flex
  ${p => {
    if (p.$paddingRight === '8') {
      return 'mr-8'
    }
    if (p.$paddingRight === '4') {
      return 'mr-4'
    }
    return 'mr-12'
  }}
`

export const TwIconRight = tw.div`
  flex
  ml-8
`

export const TwWrap = tw.div<{$truncate?: boolean}>`
  flex
  items-center
  justify-center
  w-full
  ${p => (p.$truncate ? 'truncate' : '')}
`

export const TwIcon = tw(IconTabler)`
  w-16
  h-16
  flex-none
`
